import InteractionEvent, {
  type InteractionTargetType
} from './InteractionEvent';

export type SearchInputPlacement = 'header';

export type SearchInputTargetProperties = {
  placement: SearchInputPlacement;
  search_term?: string;
};

type EventData = {
  gesture?: string;
  guestId?: string;
  isBot: boolean;
  placement: SearchInputPlacement;
  searchTerm?: string;
};

class SearchInputInteractionEvent extends InteractionEvent<
  EventData,
  SearchInputTargetProperties
> {
  protected get targetType(): InteractionTargetType {
    return 'search_input';
  }

  protected getTargetProperties(): SearchInputTargetProperties {
    return {
      placement: this.data.placement,
      search_term: this.data.searchTerm
    };
  }
}

export default SearchInputInteractionEvent;
